<!--
    @修改人: 黎柏祺
    @修改时间: 2018-10-17
    @修改描述：框架升级
    @版本:v1.0.26
    ----------------------
    @负责人: 谢汉
    @创建时间: 2018-01-24
    @版本:v1.0.13
    @描述: 灰度节点配置
    -->
<template>
    <div class="ABNodeConfig__content">
        <div class="ABNodeConfig__form">
            <el-form ref="form" :model="form" :inline="true">
                <el-form-item :label="$t('ABNodeConfig.ip')">
                    <el-input v-model="form.ipaddress" ></el-input>
                </el-form-item>
                <el-form-item :label="$t('ABNodeConfig.port')">
                    <el-input v-model="form.servPort" ></el-input>
                </el-form-item>
                <el-form-item :label="$t('ABNodeConfig.group')">
                    <g-select :list="select_group" :defaultAll="defaultAll" v-model="form.groupName"></g-select>
                </el-form-item>
                <el-form-item :label="$t('ABNodeConfig.app')">
                    <g-select :list="select_app" :defaultAll="defaultAll" v-model="form.serviceName"></g-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="e_search" v-g-rac="gRac('ABNodeConfig@search')">{{ $t('common.search') }}</el-button>
                </el-form-item>
            </el-form>         
        </div>
        <div class="ABNodeConfig__operation mb-base">
          <el-button type="primary"  @click="e_create">{{ $t('ABNodeConfig.nodeCreate') }}</el-button>
          <el-button type="primary"  @click="e_release">{{ $t('ABNodeConfig.nodeRelease') }}</el-button>
        </div>
        <div class="ABNodeConfig__table">
          <el-table-extend
          :data="tData" 
          :head="tHead"
          :currentChange="tCurrentChange"
          :sizeChange="tSizeChange"
          border>
            <template slot="control-column" slot-scope="{data}">
              <el-table-extend-control 
                v-g-rac="gRac('ABNodeConfig@delete')"
                :control="tableControl" 
                :data="data" 
                :label="$t('common.handle')">
              </el-table-extend-control>
            </template>
          </el-table-extend>
        </div>
        <dialog-form
          key="createForm"
          :title="$t('ABNodeConfig.nodeCreate')" 
          :size="3" 
          :label-size="2" 
          :visible.sync="createFormVisible" 
          :model="createForm"
          :input-data="createFormData"
          :rules="createFormRules"
          :cancel-fun="e_cancelCreate"
          :confirm-fun="isConfirmCreate">
        </dialog-form>
        <dialog-form
          key="releaseForm"
          :title="$t('ABNodeConfig.nodeRelease')" 
          :size="3" 
          :label-size="2" 
          :visible.sync="releaseFormVisible" 
          :model="releaseForm"
          :input-data="releaseFormData"
          :rules="releaseFormRules"
          :cancel-fun="e_cancelRelease"
          :confirm-fun="isConfirmRelease">
        </dialog-form>
    </div>
</template>
<script>
import dic from '@/components/mixins/dic'
import ABNodeConfig from '@/logic/continuousDelivery/ABNodeConfigBiz.js'
import table from '@/components/mixins/table'
import rac from '@/plugins/rac-mixin.js'
import validateConfig from '@/utils/validate'
import dialogForm from '@/components/dialogForm'
import { extend } from '@/utils/tool'
import TimeFormat from '@/utils/timeFormat'

export default {
  mixins: [dic, table, rac],
  data () {
    const that = this
    return {
      form: {
        ipaddress: '',
        servPort: '',
        groupName: '',
        serviceName: ''
      },
      defaultAll: true,
      currentPage: 1,
      perPageCount: 10,
      select_app: {},
      tableControl: [{
        label: that.$t('common.delete'),
        callback: that.e_delete
      }],
      createFormVisible: false,
      createForm: {
        ipaddress: '',
        servPort: '',
        groupName: '',
        serviceName: '',
        descs: ''
      },
      createFormRules: {},
      releaseFormVisible: false,
      releaseForm: {
        groupName: '',
        serviceName: ''
      },
      releaseFormRules: {},
      createFormData: [],
      releaseFormData: [],
      select_group: {}
    }
  },
  computed: {
  },
  methods: {
    async waitGroupList () {
      await this.dGetGroup()
      this.select_group = this.$store.state.dicModule.group
      this.setDialogData()
    },
    async waitAppList (group, num) {
      await this.dGetAppByGroup('', group)
      switch (num) {
        case 1:
          this.select_app = { ...this.dDictionaryApp[group] }
          this.form.serviceName = Object.keys(this.select_app)[0]
          break
        case 2:
          this.$set(this.createFormData[3], 'select', this.dDictionaryApp[group])
          this.createForm.serviceName = Object.keys(this.dDictionaryApp[group])[0]
          break
        default:
          this.$set(this.releaseFormData[1], 'select', this.dDictionaryApp[group])
          this.releaseForm.serviceName = Object.keys(this.dDictionaryApp[group])[0]
      }
    },
    e_init () {
      this.waitGroupList()
      this.initTable()
      this.search()
    },
    setDialogData () {
      this.createFormData = [
        {
          label: this.$t('ABNodeConfig.ip'),
          key: 'ipaddress',
          inputWidth: '400px'
        },
        {
          label: this.$t('ABNodeConfig.port'),
          key: 'servPort',
          inputWidth: '400px'
        },
        {
          label: this.$t('ABNodeConfig.group'),
          key: 'groupName',
          type: 'select',
          select: this.select_group,
          inputWidth: '400px'
        },
        {
          label: this.$t('ABNodeConfig.app'),
          key: 'serviceName',
          type: 'select',
          select: {},
          inputWidth: '400px'
        },
        {
          label: this.$t('ABNodeConfig.desc'),
          key: 'descs',
          type: 'textarea',
          inputWidth: '400px'
        }
      ]
      this.releaseFormData = [
        {
          label: this.$t('ABNodeConfig.group'),
          key: 'groupName',
          type: 'select',
          select: this.select_group,
          inputWidth: '400px'
        },
        {
          label: this.$t('ABNodeConfig.app'),
          key: 'serviceName',
          type: 'select',
          select: {},
          inputWidth: '400px'
        }]
      const array1 = ['ipaddress', 'servPort', 'groupName', 'serviceName']
      const array2 = ['groupName', 'serviceName']
      array1.map((item) => {
        this.createFormRules[item] = [{ ...validateConfig.common.notEmpty }]
      })
      array2.map((item) => {
        this.releaseFormRules[item] = [{ ...validateConfig.common.notEmpty }]
      })
    },
    initTable () {
      this.tInitTable({
        lanKey: 'ABNodeConfig.table',
        head: ['ipaddress', 'servPort', 'groupName', 'serviceName', 'descs', 'releaseTime'],
        requestFun: this.search,
        headOpt: {}
      })
    },
    search () {
      const reqData = extend(true, { ...this.tPageInfo }, this.form)
      ABNodeConfig.findNode(reqData).then((data) => {
        if (data && data.dataList) {
          data.dataList.map((item) => {
            item.releaseTime = TimeFormat.getFormatTime(item.releaseTime)
          })
        }
        this.tData = data
      })
    },
    e_search () {
      this.tResetPage()
      this.search()
    },
    e_create () {
      this.createFormVisible = true
    },
    e_release () {
      this.releaseFormVisible = true
    },
    e_delete (data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        ABNodeConfig.deleteNode({ id: data.id }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.search()
          }, 500)
        })
      }).catch(() => {})
    },
    e_cancelCreate () {
      this.createFormVisible = false
      Object.keys(this.createForm).forEach((item) => {
        this.createForm[item] = ''
      })
    },
    e_cancelRelease () {
      this.releaseFormVisible = false
      Object.keys(this.releaseForm).forEach((item) => {
        this.releaseForm[item] = ''
      })
    },
    isConfirmCreate (data) {
      ABNodeConfig.createNode(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        setTimeout(() => {
          this.e_cancelCreate()
          this.search()
        }, 500)
      })
    },
    isConfirmRelease (data) {
      ABNodeConfig.releaseNode(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        setTimeout(() => {
          this.e_cancelRelease()
          this.search()
        }, 500)
      })
    }
  },
  components: {
    dialogForm
  },
  mounted () {
    this.e_init()
  },
  watch: {
    'form.groupName' () {
      this.waitAppList(this.form.groupName, 1)
    },
    'createForm.groupName' () {
      this.waitAppList(this.createForm.groupName, 2)
    },
    'releaseForm.groupName' () {
      this.waitAppList(this.releaseForm.groupName, 3)
    }
  }
}
</script>

<style>
    .ABNodeDialog .text-control {
        width: 450px;
    }
    .ABNodeDialog .modal-content {
        overflow: inherit;
    }
    .ABNodeDialog .modal-body {
        overflow: inherit;
    }
    .ABNodeDialog .label-control {
        margin-right: 10px;
        width: 80px;
        text-align: right;
        display: inline-block;
    }
</style>